/**
 * Route names defined for routes that only organizer user type can access.
 */
export const organizerRouteNames = {
  organizations: 'organizations',
  createOrganization: 'create-organization',
  eventInfo: 'event-info',
  eventWorkers: 'event-workers',
  eventCategories: 'event-categories',
  accreditations: 'accreditations',
  requests: 'requests',
  createAccreditation: 'create-accreditation',
  editAccreditation: 'update-accreditation',
  accreditationBuilder: 'builder-accreditation',
  eventDocumentation: 'eventDocumentation',
  eventLegalEntityInvoices: 'event-legal-entity-invoices',
  superAdmin: 'super-admin',
  eventDashboard: 'event-dashboard',
  floorPlanOverview: 'floor-plan-overview',
  documentation: 'documentation',
  visitorStatistics: 'visitor-stats-container',
  scannedTickets: 'scanned-tickets-container',
  referrals: 'referrals',
  promoteEvent: 'promote-event',
  organizer: 'organizer',
  inviteAttendee: 'invite-attendee',
  curatedInvitations: 'curated-invitations',
  createEmailInvitation: 'create-email-invitation',
  emailsToInvitees: 'emails-to-invitees',
  eventWorkshops: 'event-workshops',
  newWorkshop: 'new-workshops',
  updateWorkshop: 'update-workshops',
  scanEntries: 'scan-entries',
  attendeeFields: 'attendee-fields',
  eventConferenceData: 'event-conference-data',
  eventAnnouncements: 'event-announcements',
  newAnnouncement: 'new-announcements',
  displayAnnouncement: 'display-announcement',
  eventTranslate: 'event-translate',
  eventHalls: 'event-halls',
  newHall: 'new-halls',
  updateHall: 'update-halls',
  importExport: 'import-export',
  import: 'import',
  export: 'export',
  editInvite: 'invite-edit-container',
  emails: 'emails',
  messageToAttendees: 'messageToAttendees',
  createEmail: 'create-email',
  emailDetails: 'email-details',
  updateEmail: 'update-email',
  tickets: 'tickets',
  floorPlan: 'floorPlan',
  createTicket: 'create-ticket',
  createGratisTicket: 'create-gratis-ticket',
  editTicket: 'edit-ticket',
  addTicket: 'add-ticket',
  createEvent: 'create-event',
  events: 'events',
  invite: 'invite',
  createTrialAccount: 'create-trial-account',
  successfulPayment: 'successful-payment',
  storeSuccessfulPayment: 'store-successful-payment',
  customSuccessfulPayment: 'custom-successful-payment',
  eventExtraModules: 'event-extra-modules',
}

export const organizationRouteNames = {
  organizationEvents: 'organization-events',
  liveEvents: 'organization-live-events',
  pastEvents: 'organization-past-events',
  organizationAddEvent: 'organization-add-event',
  organizationProfileInfo: 'organization-profile-info',
  organizationFinanceInfo: 'organization-finance-info',
  organizationContractsAndTerms: 'organization-terms-of-use-form',
  organizationMailingList: 'organization-mailing-list',
  organizationSubscribers: 'organization-subscribers',
  organizationMessages: 'organization-messages',
  organizationUsers: 'organization-users',
  organizationLoyaltyCoupons: 'organization-loyalty-coupons',
  organizationLoyaltyCouponAdd: 'organization-loyalty-coupon-add',
  organizationPromoCodes: 'organization-promo-codes',
  organizationPromoCodeInfo: 'organization-promo-code-info',
  ticketCategories: 'ticket-categories',
  organizationReports: 'organization-reports',
}
